import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { ActionBar, Link, Modal } from '@beef/ui-kit';
import { withAnalyticsModal } from "../../hocs";
import { BaseLayout } from "./components";
import { useAnchorModal } from "./hooks/useAnchorModal";
var CONTENT_BY_TYPE = {
  base: BaseLayout
};
var _AnchorModal = function _AnchorModal(_ref) {
  var anchorKey = _ref.anchorKey,
    size = _ref.size,
    isCloseButtonVisible = _ref.isCloseButtonVisible,
    headerBarConfig = _ref.headerBarConfig,
    actionButtons = _ref.actionButtons,
    content = _ref.content,
    onClick = _ref.onClick,
    onView = _ref.onView,
    classes = _ref.classes;
  var _useAnchorModal = useAnchorModal(anchorKey, onView),
    isOpen = _useAnchorModal.isOpen,
    onClose = _useAnchorModal.onClose;
  var handleClick = function handleClick(text, index, isCloseButton) {
    onClick === null || onClick === void 0 ? void 0 : onClick(text, index);
    if (isCloseButton) {
      onClose();
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    actionBar: actionButtons ? /*#__PURE__*/React.createElement(ActionBar, {
      size: "s"
    }, actionButtons.map(function (_ref2, index) {
      var text = _ref2.text,
        link = _ref2.link,
        variant = _ref2.variant,
        isCloseButton = _ref2.isCloseButton;
      return /*#__PURE__*/React.createElement(Link, {
        buttonSize: "l",
        buttonVariant: variant,
        href: link,
        onClick: function onClick() {
          return handleClick(text, index, isCloseButton);
        },
        variant: "button"
      }, text);
    })) : undefined,
    headerBarConfig: headerBarConfig,
    isCloseButtonVisible: isCloseButtonVisible,
    isOpen: isOpen,
    onClose: onClose,
    size: size,
    "data-t-id": "components-AnchorModal"
  }, (content === null || content === void 0 ? void 0 : content.length) > 0 && content.map(function (_ref3) {
    var type = _ref3.type,
      data = _ref3.data;
    var ContentComponent = CONTENT_BY_TYPE[type];
    if (!ContentComponent) return null;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      React.createElement(ContentComponent, _extends({}, data, {
        classes: classes
      }))
    );
  }));
};
_AnchorModal.displayName = _AnchorModal.name;
export var AnchorModal = withAnalyticsModal( /*#__PURE__*/memo(_AnchorModal));